import React from "react";
import Container from "../General/Container/Container";
import { Button, Collapse, Tag, Tooltip } from "antd";
import { FolderFilled, InfoCircleOutlined, MinusSquareOutlined, PlusSquareOutlined } from "@ant-design/icons";
import { fGetBehaviorMatchAndColor } from "../../utils/oneintelligence/OneIntelligenceHelper";
import CustomTable from "../../customcomponents/customtable/CustomTable";
import { deepDiveColumns } from "../../config/TableColumns.config";
import { HiOutlineLightBulb } from "react-icons/hi";
import CrownSubscription from "../ReportBuilder/Insights/CrownSubscription";
import { setVisibleInsightsModal } from "../../store/components/Reports.slice";
import TableProgress from "../General/TableProgress";
import useShowInsights from "../../hooks/useShowInsights";
import { useDispatch } from "react-redux";
import { folderStyle, formatNumber } from "../../utils/MainHelper";
import { getWhiteLabelDictionary } from "../../utils/whitelabel/WhiteLabel.Helper";
const { Panel } = Collapse
const MinifiedCollapse = ({
    type = "he",
    list,
    activeKey,
    onChange = () => { },
    selected = {},
    setSelected = () => { }
}) => {
    const dispatch = useDispatch()

    const interestLevelObj = fGetBehaviorMatchAndColor(type === "he" ? .5 : .3)
    const getTitle = () => {
        return <Tag
            className={"collapse-header-" + interestLevelObj.behaviormatch}
            style={{
                color: interestLevelObj.color,
                background: interestLevelObj.bg,
                border: "none",
                fontWeight: 600,
                fontSize: "14px"
            }}>
            {getWhiteLabelDictionary(interestLevelObj.behaviormatch, interestLevelObj.behaviormatch)}
        </Tag>
    }

    const { showInsights } = useShowInsights()

    const newColumns = deepDiveColumns.reduce((acc, col) => {
        if (!(!col.type || col.type === "column") || ["behaviormatch"].includes(col.key)) return acc
        const colObj = {
            ...col,
            dataIndex: col.key
        };
        switch (col.key) {
            case "item": {
                colObj.render = (value, row) => {
                    const newValue = value.includes(":") ? value.split(":")[1].trim() : value;

                    const hasChildren = row.tempChildren || row.children;
                    return (
                        <p className="d-flex" >
                            <span style={{
                                whiteSpace: "prewrap",
                                width: hasChildren ? "calc(100% - 6mm)" : "100%"
                            }}
                            >
                                {newValue}
                            </span>
                        </p>
                    );
                };
                break;
            }
            case "score": {
                colObj.title = (
                    <div style={{
                        whiteSpace: "nowrap"
                    }}
                    >
                        <Tooltip
                            placement="bottomLeft"
                            title="Hover on the chart to see the score details."
                        >
                            <InfoCircleOutlined style={{
                                cursor: "pointer",
                                color: "#A3AED0",
                                fontWeight: "bold",
                                fontSize: "14px",
                                marginRight: "2mm"
                            }}
                            />
                        </Tooltip>
                        <span>{colObj.title}</span>
                    </div>
                );
                colObj.render = (value, {
                    score, item, mastersName, masterSize, share: shareVal
                }) => {
                    let min = mastersName;
                    let max = item;

                    if (shareVal < masterSize) {
                        min = item;
                        max = mastersName;
                    }

                    return (
                        <div className="d-flex align-items-center onHover">
                            <Tooltip
                                placement="bottomLeft"
                                title={`${(score * 100).toFixed(2)}% of people engaging ${min} are also engaging ${max}`}
                            >
                                <div style={{
                                    width: "100%",
                                    cursor: "pointer"
                                }}
                                >
                                    <TableProgress
                                        value={value}
                                        color={interestLevelObj.color}
                                    />
                                </div>
                            </Tooltip>
                        </div>
                    );
                };
                break;
            }
            case "share":
            case "masterSize": {
                colObj.width = 120;
                colObj.render = (value) => formatNumber(value);
                break;
            }
            case "audienceIntersect": {
                colObj.width = 120;
                colObj.render = (value) => formatNumber(value);
                break;
            }
            case "insights": {
                if (showInsights) {
                    colObj.title = "";
                    colObj.width = 40;
                    colObj.render = (value, row) => (
                        <Button
                            className="hoverbulb"
                            type="link"
                            onClick={() => {
                                dispatch(setVisibleInsightsModal({
                                    data: { ...row, ...interestLevelObj, fromMinified: true },
                                    trackName: "minified insights",
                                    trackKey: "minifiedClickInsights",
                                    visible: true
                                }));
                            }}
                        >
                            <HiOutlineLightBulb style={{
                                fontSize: "5mm"
                            }}
                            />
                            <CrownSubscription style={{
                                fontSize: "10px", position: "absolute", top: 0
                            }}
                            />
                        </Button>
                    );
                }
                break;
            }
            default:
        }
        if (showInsights && col.key === "insights") {
            acc.push(colObj)
        } else if (col.key !== "insights") {
            acc.push(colObj)
        }
        return acc;
    }, []);


    const getRowSelection = (categoryName) => {
        return {
            selectedRowKeys: (selected[categoryName] || []).map((item) => item.key),
            onChange: (selectedRowKeys, selectedRows) => {
                setSelected((state) => {
                    return {
                        ...state,
                        [categoryName]: selectedRows
                    }
                });
            }
        }
    }

    return <Container className="minified-result-item collapse f1">
        <Container className="minified-result-listcont dcol">
            <Container className="minified-result-listcont-header drow justify-between">
                {getTitle()}
                <Container className="drow">
                    <Tag className="minified-header-tag pad-0">Total:</Tag>
                    <Tag className="minified-header-tag pad-0">{list.length}</Tag>
                </Container>
            </Container>
            <Container className="minified-result-listcont-body dcol gap-1">
                {list.map((category) => {
                    return <Collapse
                        activeKey={activeKey}
                        onChange={(e) => { onChange(e) }}
                        className={`collapse-${category.discoveredCategory.replace(/ /g, "_")}-${interestLevelObj.behaviormatch.replace(/ /g, "_")}`}
                        key={category.discoveredCategory}
                        bordered={false}
                        expandIcon={({ isActive }) => {
                            if (isActive) return <MinusSquareOutlined />
                            return <PlusSquareOutlined />
                        }}>
                        <Panel
                            key={category.discoveredCategory}
                            header={<Container className="d-row align-center">
                                <FolderFilled style={folderStyle} />
                                <span>{category.discoveredCategory}</span>
                            </Container>}
                            extra={<Container className="drow">
                                <Tag className="minified-header-tag pad-0">Behaviors:</Tag>
                                <Tag className="minified-header-tag pad-0">{category.children.length}</Tag>
                            </Container>}
                        >
                            <CustomTable
                                noNum
                                pagination={false}
                                columns={newColumns}
                                rowSelection={getRowSelection(category.discoveredCategory)}
                                dataSource={category.children}
                                expandable={{ showExpandColumn: false }}
                            />
                        </Panel>
                    </Collapse>
                })}
            </Container>
        </Container>
    </Container>
}

export default MinifiedCollapse